import React from "react";
import "../post.css";
import DayEight from "../images/day_eight.jpg";

export default class Post extends React.Component {
  render() {
    return (
      <div className="card">
        <h2 className="header">Day Eight</h2>
        <img className="image" alt="itinerary" src={DayEight} />
        <div className="infobar">
          <div className="info">27 Nov 2018</div>
        </div>
        <h3>Morning</h3>
        <p>
          Kuromon Ichiba Market. This morning market is a tourist attractions
          with tourist prices. Interesting things to look out for include
          pufferfish, whale meat, sea urchin, etc. Seafood here is extremely
          fresh and delicious.
        </p>
        <h3>Afternoon</h3>
        <p>
          Namba Parks. It's a multi-storey park planted on top of a shopping
          mall. It's just a place to relax. Get some desserts after that.
        </p>
        <h3>Evening</h3>
        <p>
          Den Den Town. Similar to Akihabara. It's a filled with tech and anime.
          You can walk up to Tennoji where the Tsutenkaku tower is. Experience a
          mix of culture between the modern and the old.
        </p>
        <p>
          Head home early for a good rest. The next day is the highlight of the
          trip - Universal Studios.
        </p>
      </div>
    );
  }
}
